// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeader3PL_header__1Otz2","title":"SubHeader3PL_title__Y0e3n","small":"SubHeader3PL_small__13Qgc","btnContainer":"SubHeader3PL_btnContainer__1LRlz"};